import wait from '@utils/misc/wait';
import {
    RETRY_CHUNK_IMPORTS_NB,
    RETRY_CHUNK_IMPORTS_INTERVAL,
} from '@utils/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ImportFnReturn = Promise<{ default: React.ComponentType<any> }>;
type ImportFn = () => ImportFnReturn;

// This will retry a few times if a chunk fails to load.
export const importRetry = async (
    importFn: ImportFn,
    retries = RETRY_CHUNK_IMPORTS_NB,
    interval = RETRY_CHUNK_IMPORTS_INTERVAL,
): ImportFnReturn => {
    try {
        return await importFn();
    } catch (error) {
        if (retries) {
            await wait(interval);
            return importRetry(importFn, retries - 1, interval);
        }
        throw new Error(error);
    }
};
